import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { PLATFORM_ICONS } from '../../../helpers/constants/platform-icons.constant';

@Component({
  selector: 'app-summary-view',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './summary-view.component.html',
  styleUrl: './summary-view.component.css',
})
export class SummaryViewComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  isLoading: boolean = false;
  endpoint = environment.api_endpoint;
  fieldsData: any;
  constructor(
    private formService: FormsServiceService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    this.getData();
  }

  /** Function to get the data by api or static */
  getData() {
    if (this.fields.options.isStatic === false) {
      this.fieldsData = this.fields.options.staticOptions;
    } else {
      const formId = this.fields.options.source.formID;
      const api_endpoint = this.endpoint;
      const method = this.fields.options.source.method;
      let url = this.fields.options.source.apiUrl;
      const replacements = {
        formID: formId,
        api_endpoint: api_endpoint,
      };
      url = this.formService.replaceTemplateTokens(url, replacements);
      url = url.replace('status=connected', 'status=Connected');
      const headers = {
        'Content-Type': 'application/json',
      };
      this.formService.loadData(method, url, headers).subscribe({
        next: (res: any) => {
          this.fieldsData = res.data;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          this.cdr.detectChanges();
        },
      });
    }
  }

  getPlatformIcon(option: any): string {
    return (
      option?.iconUrl ||
      PLATFORM_ICONS[option?.platformName] ||
      PLATFORM_ICONS['default']
    );
  }

  onImageError(event: Event, option: any) {
    const element = event.target as HTMLImageElement;

    element.src =
      PLATFORM_ICONS[option?.platformName] || PLATFORM_ICONS['default'];
  }
}
